import { EngagementAgeEnum } from '../enum/engagement-age.enum';
import { EngagementEventTypeEnum } from '../enum/engagement-event-type.enum';

export interface EngagementValue {
    age: EngagementAgeEnum;
    count: number;
}

export class EngagementDataModel {
    engagementValues: EngagementValue[];
    type: EngagementEventTypeEnum;

    constructor(type: EngagementEventTypeEnum, values: EngagementValue[]) {
        this.type = type;
        this.engagementValues = values;
    }
}
